import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/szKUaQKVPy3X24Bp79SjXE/modulo_1_(7).png',
  label: 'Módulo 1 · El período Edo y el nacimiento del irezumi artístico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qxt67Z6G627pMfvPz2K4p2/modulo_2_(7).png',
  label: 'Módulo 2 · La máscara Hannya'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pZZVf4ZdeiBvgpW88x7ruK/modulo_2_(14).png',
  label: 'Módulo 2 · La Geisha'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eBiZfyNg2aSM7D3Cu8Kw2e/modulo_5_(10).png',
  label: 'Módulo 5 · Pecho y torso · La construcción del irezumi'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rMY9q7ajnYXFNoqjjPJpCt/modulo_6_(5).png',
  label: 'Módulo 6 · Cómo elegir un buen tatuador'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dsa7nPxZbv9szMr6tQ92Wp/BONUS_PREMIUM_(3).png',
  label: 'Bonus Premium · Mangas japonesas · Dragón tradicional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wv3umCAX9VK5beFYJHgYnN/BONUS_PREMIUM_(15).png',
  label: 'Bonus Premium · Mangas japonesas · Neo Japonés'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cN9TZreseEeM6FuKUTm3Wh/BONUS_PREMIUM_(30).png',
  label: 'Bonus Premium · Espaldas completas · Geisha'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/59rTsYJnbRfxkYCf1DUytB/BONUS_PREMIUM_(59).png',
  label: 'Bonus Premium · Ukiyo-e y personajes clásicos · Kabuki'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3xXJ5fV5uehuPs3Fka9A6J/BONUS_PREMIUM_(62).png',
  label: 'Bonus Premium · Ukiyo-e y personajes clásicos · Momotaro'
}];
export function PreviewSection() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0);
  const go = (d: number) => {
    setDir(d);
    setIndex(p => (p + d + slides.length) % slides.length);
  };
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-289">
      <div className="max-w-5xl mx-auto" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-291">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-292">
            👀 Mirá{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-293">
              por dentro
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-3" data-id="element-294">
            Páginas reales de la colección.
          </p>
        </motion.div>

        <div className="relative" data-id="element-295">
          <div className="relative bg-bg-warm border border-line rounded-3xl p-3 md:p-5 shadow-xl" data-id="element-296">
            <div className="relative aspect-[3/4] md:aspect-[4/3] rounded-2xl overflow-hidden bg-bg-warm" data-id="element-297">
              <AnimatePresence initial={false} mode="wait" data-id="element-298">
                <motion.img key={index} src={slides[index].src} alt={slides[index].label} initial={{
                opacity: 0,
                x: dir > 0 ? 50 : -50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: dir > 0 ? -50 : 50
              }} transition={{
                duration: 0.4
              }} className="absolute inset-0 w-full h-full object-contain" data-id="element-299" />
              </AnimatePresence>
            </div>
          </div>

          <button onClick={() => go(-1)} aria-label="Anterior" className="absolute left-1 md:-left-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-bg-warm border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-300">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-301" />
          </button>
          <button onClick={() => go(1)} aria-label="Siguiente" className="absolute right-1 md:-right-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-bg-warm border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-302">
            <ChevronRightIcon className="w-5 h-5" data-id="element-303" />
          </button>
        </div>

        <div className="flex flex-col items-center gap-4 mt-6" data-id="element-304">
          <div className="text-sm text-muted font-medium text-center px-4 font-serif-italic" data-id="element-305">
            {slides[index].label}
          </div>
          <div className="flex gap-2" data-id="element-306">
            {slides.map((_, i) => <button key={i} aria-label={`Slide ${i + 1}`} onClick={() => {
            setDir(i > index ? 1 : -1);
            setIndex(i);
          }} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-8 bg-rose' : 'w-1.5 bg-rose/25'}`} data-id="element-307" />)}
          </div>
        </div>

        <p className="text-center font-serif-italic text-rose mt-8 text-lg" data-id="element-308">
          Una biblioteca visual dedicada al tatuaje japonés
        </p>
      </div>
    </section>;
}